import { render } from "./UserAdminEdit.vue?vue&type=template&id=235560b8"
import script from "./UserAdminEdit.vue?vue&type=script&lang=js"
export * from "./UserAdminEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserAdminEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "235560b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('235560b8', __exports__)) {
    api.reload('235560b8', __exports__)
  }
  
  module.hot.accept("./UserAdminEdit.vue?vue&type=template&id=235560b8", () => {
    api.rerender('235560b8', render)
  })

}


export default __exports__